import { app } from '../../../app';
import { Controller } from './google-marketplace-configuration-login.controller';

app.component('googleMarketplaceConfigurationLogin', {
    templateUrl: require('./google-marketplace-configuration-login.html'),
    controller: Controller,
});



// WEBPACK FOOTER //
// ./src/portal/states/public/google-marketplace-configuration-login/google-marketplace-configuration-login.component.js